import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import { DownloadFile } from '@/core/utils'

export default {
	async [actionTypes.GERAR_RELATORIO.BAIXAR_RELATORIO](context, obj) {
		const response = await api.gerarRelatorio.baixarRelatorio(obj.tipoHistorico, obj.entidadeId)
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
}
